import { useContext } from 'react';
import Scrollbar from '../../../src/components/Scrollbar';
import { SidebarContext } from '../../../src/contexts/SidebarContext';

import { Box, Drawer, styled, useTheme } from '@mui/material';

import SidebarMenu from './SidebarMenu';
import SidebarFooter from './SidebarFooter';
import { Link as RouterLink } from 'react-router-dom';
import LogoCoinhouse from '../../components/Logo/LogoCoinhouse';
import { useAuthState } from 'react-admin';

// Logo row (aligned with the header), scrollable navigation, signed-in user pinned at the bottom.
const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        min-width: ${theme.sidebar.width};
        color: ${theme.colors.alpha.trueWhite[70]};
        background: ${theme.sidebar.background};
        position: relative;
        z-index: 7;
        height: 100%;
        display: flex;
        flex-direction: column;
`
);

const LogoRow = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        flex-shrink: 0;
        display: flex;
        align-items: center;
        padding: 0 ${theme.spacing(3)};
        border-bottom: 1px solid ${theme.colors.alpha.trueWhite[10]};

        a {
          display: flex;
          border-radius: 4px;
        }

        svg {
          height: 26px;
          width: auto;
        }
`
);

const SidebarContent = ({ authenticated }: { authenticated: boolean }) => (
  <>
    <LogoRow>
      <RouterLink to="/" aria-label="Coinhouse">
        <LogoCoinhouse fillColor="white" />
      </RouterLink>
    </LogoRow>
    <Box sx={{ flex: 1, minHeight: 0, pt: 1 }}>
      <Scrollbar>{authenticated && <SidebarMenu />}</Scrollbar>
    </Box>
    {authenticated && <SidebarFooter />}
  </>
);

function Sidebar() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();
  const theme = useTheme();
  const { authenticated } = useAuthState();
  return (
    <>
      <SidebarWrapper
        sx={{
          display: {
            xs: 'none',
            lg: 'flex'
          },
          position: 'fixed',
          left: 0,
          top: 0
        }}
      >
        <SidebarContent authenticated={authenticated} />
      </SidebarWrapper>
      <Drawer
        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
        open={sidebarToggle}
        onClose={closeSidebar}
        variant="temporary"
        elevation={9}
      >
        <SidebarWrapper>
          <SidebarContent authenticated={authenticated} />
        </SidebarWrapper>
      </Drawer>
    </>
  );
}

export default Sidebar;
